// extracted by mini-css-extract-plugin
export default {"welcome":"welcome_welcome__kSpll","mark":"welcome_mark__pmkZM"};